import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const image12MmaVerticalRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'mma_1x2',
  className: 'mma_1x2',
  aspectRatio: 0.5,
  type: 'Image1x2',
  associationType: 'ImageMedia1x2',
  imagePreviewHeight: 400,
  isRequired: true,
  minimumRequirements: 0,
  minSize: [470, 940],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Vertical image'),
    stringKey: _TL_('1:2'),
  },
  previewSettings: {
    showAdsLabel: true,
    showImage: true,
    showDescription: true,
    showShortHeadline: true,
    showAdditionalDisclaimer: true,
    showAction: true,
    showUrl: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    adsLabel: {
      backgroundColor: 'white',
    },
    gradient: {
      backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
      width: '100%',
      height: 400,
      display: 'block',
      position: 'absolute',
    },
    description: {
      color: 'white',
      bottom: 5,
      position: 'relative',
      fontSize: 14,
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
      height: 400,
    },
    shortHeadline: {
      fontSize: 24,
      position: 'relative',
      color: 'white',
      bottom: 20,
      fontWeight: 200,
      paddingBottom: 5,
    },
    finalUrl: {
      color: 'green',
      fontSize: 10,
      bottom: 15,
      position: 'relative',
    },
    actionButton: {
      padding: '5px 16px 6px 16px',
      position: 'relative',
      top: 5,
      fontSize: 14,
      borderRadius: 3,
    },
    textContainer: {
      left: 0,
      position: 'absolute',
      lineHeight: 1.1,
      paddingLeft: 32,
      bottom: 25,
      fontSize: 10,
    },
  },
};

export default image12MmaVerticalRaw;
